var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{style:({fontSize:_vm.size,background:_vm.bg})},[_c('span',{style:({color:_vm.textColor})},[_vm._v(_vm._s(_vm.text))]),(_vm.num)?_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.num))]):_vm._e()]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }